'use strict';

/**
 * @author Maxim Seredkin
 */
export default function projectLandTable() {
  return {
    restrict: 'A',
    template: require('../view/project-progress.html'),
    transclude: false,
    scope: {
      projectProgresses: '=?myProjectProgresses',
      projectSubProgresses: '=?myProjectSubProgresses',
      edit: '=edit',
    },
    controller: [
      '$scope',
      '$utils',
      '$timeout',
      'PhaseService',
      function ($scope, $utils, $timeout, PhaseService) {
        console.log('tuta', $scope);
        $scope.selectedItem = null;
        $scope.getPhaseProgresses = getPhaseProgresses;
        $scope.select = select;
        $scope.isSelected = isSelected;
        $scope.isSelect = isSelect;
        $scope.addProjectSubProgressButtonClick =
          addProjectSubProgressButtonClick;
        $scope.removeProjectSubProgress = removeProjectSubProgress;
        $scope.getProjectSubProgressIdForNameInputElement =
          getProjectSubProgressIdForNameInputElement;
        $scope.refreshGantt = refreshGantt;
        $scope.onPhaseDateChange = onPhaseDateChange;

        $scope.currentDate = new Date();

        let phases = [];

        init();

        $scope.resizeHandler = function () {
          $scope.$digest();
        };

        // region Function

        function init() {
          if (!$scope.selectedItem) {
            $scope.selectedItem = {};
          }

          $scope.dateFormat = 'dd.MM.yyyy';

          PhaseService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['npp:ASC', 'name:ASC'],
            },
            (data) => {
              phases = data._embedded;
              mapping();
              $scope.$watch('projectProgresses', function () {
                mapping();
              });
            }
          );

          $scope.ganttOptions = {
            scale: 'month',
            header: 'Наименование',
          };

          $scope.viewType = 'table';
        }

        function mapping() {
          let backupItems = $scope.projectProgresses;

          let map = phases.map((phase) => {
            if (Array.isArray(backupItems)) {
              let progress = backupItems.find(
                (item) => item.phase.id == phase.id
              );
              if (progress) {
                return progress;
              } else {
                return { phase: phase };
              }
            }
          });

          if (Array.isArray(phases)) {
            angular.copy(map, $scope.projectProgresses);
          }
        }

        function getPhaseProgresses(phaseId) {
          return $scope.projectSubProgresses
            ? $scope.projectSubProgresses.filter((subProgress) =>
                subProgress.phaseId
                  ? subProgress.phaseId === phaseId
                  : subProgress.phase.id === phaseId
              )
            : [];
        }

        /**
         * Выбрана ли запись
         * @return {boolean}
         */
        function isSelected() {
          return (
            $scope.selectedItem != null &&
            !angular.equals($scope.selectedItem, {})
          );
        }

        /**
         * Выбрать элемент
         * @param {*} item выбираемый элемент
         */
        function select(item) {
          if (!$scope.isSelect(item)) {
            angular.copy(item, $scope.selectedItem);
          } else {
            angular.copy({}, $scope.selectedItem);
          }
        }

        /**
         * Выбрал ли элемент!
         * @param {*} item проверяемый элемент
         * @return {bool}
         */
        function isSelect(item) {
          return equals(getSelected(), item);
        }

        /**
         * Проверка элементов на равенство
         * @param {*} i1
         * @param {*} i2
         * @return {*}
         */
        function equals(i1, i2) {
          return angular.equals(i1, i2);
        }

        /**
         * Обработчик события клика на кнопку добавления подэтапа проекта
         */
        function addProjectSubProgressButtonClick() {
          let selectedItem = getSelected();

          if (!selectedItem) {
            return;
          }

          let newSubProgress = addProjectSubProgress(selectedItem.phase.id);
          angular.copy({}, $scope.selectedItem);

          let inputElementId =
            getProjectSubProgressIdForNameInputElement(newSubProgress);

          $timeout(() => focusOnElement(inputElementId));
        }

        /**
         * Сфокусироваться на элементе
         * @param id
         */
        function focusOnElement(id) {
          let focusElement = document.getElementById(id);

          if (!focusElement) {
            return;
          }

          focusElement.focus();
        }

        /**
         * Получить выбранный элемент
         * @return {{}|*}
         */
        function getSelected() {
          return $scope.selectedItem;
        }

        /**
         * Добавить подэтап проекта
         * @param phaseId
         */
        function addProjectSubProgress(phaseId) {
          let newSubProgress = {
            tempId: new Date().getTime(),
            name: '',
            phaseId: phaseId,
            planStartDate: null,
            planEndDate: null,
            startDate: null,
            endDate: null,
            comment: '',
          };

          $scope.projectSubProgresses.push(newSubProgress);

          return newSubProgress;
        }

        /**
         * Удалить подэтап проекта
         * @param subProgressId
         */
        function removeProjectSubProgress(subProgressId) {
          $scope.projectSubProgresses = $scope.projectSubProgresses.filter(
            (subProgress) => subProgress.id !== subProgressId
          );
        }

        /**
         * Получить id для инпута с именем подэтапа
         * @param subProgress
         * @returns {string}
         */
        function getProjectSubProgressIdForNameInputElement(subProgress) {
          let idPrefix = 'subProgressNameInput-';
          let id = subProgress.tempId ? subProgress.tempId : subProgress.id;

          return `${idPrefix}${id}`;
        }

        function onPhaseDateChange(item, type, vid) {
          $scope.projectSubProgresses = $scope.projectSubProgresses.map(
            (sub) => {
              if (
                !(sub.phaseId
                  ? sub.phaseId === item.phase.id
                  : sub.phase.id === item.phase.id)
              ) {
                return sub;
              }

              if (type === 'plan') {
                if (vid === 'start') {
                  if (
                    sub.planStartDate &&
                    sub.planStartDate < item.planStartDate
                  )
                    sub.planStartDate = new Date(item.planStartDate);
                  if (sub.planEndDate && sub.planEndDate < item.planStartDate)
                    sub.planEndDate = new Date(item.planStartDate);
                }
                if (vid === 'end') {
                  if (sub.planEndDate && sub.planEndDate > item.planEndDate)
                    sub.planEndDate = new Date(item.planEndDate);
                  if (sub.planStartDate && sub.planStartDate > item.planEndDate)
                    sub.planStartDate = new Date(item.planEndDate);
                }
              }
              if (type === 'fact') {
                if (vid === 'start') {
                  if (sub.startDate && sub.startDate < item.startDate)
                    sub.startDate = new Date(item.startDate);
                  if (sub.endDate && sub.endDate < item.startDate)
                    sub.endDate = new Date(item.startDate);
                }
                if (vid === 'end') {
                  if (sub.endDate && sub.endDate > item.endDate)
                    sub.endDate = new Date(item.endDate);
                  if (sub.startDate && sub.startDate > item.endDate)
                    sub.startDate = new Date(item.endDate);
                }
              }
              return sub;
            }
          );
        }
        /**
         * Обновить данные диаграммы Ганта
         */
        function refreshGantt() {
          $scope.projectProgresses = !!$scope.projectProgresses
            ? $scope.projectProgresses
            : [];
          let rows = [];

          // собираем данные этапов
          $scope.projectProgresses.forEach((progress, progressIndex) => {
            progressIndex = progressIndex + 1;

            let processName = `${progressIndex}. ${progress.phase.name}`;
            rows.push({
              name: processName,
              tasks: [
                !!progress.startDate
                  ? {
                      name: progress.phase.name + ' - Факт',
                      from: Math.min(new Date(progress.startDate), new Date()),
                      to: !!progress.endDate
                        ? Math.min(new Date(progress.endDate), new Date())
                        : new Date(),
                      classes: ['section-1'],
                    }
                  : null,
                !!progress.planStartDate
                  ? {
                      name: progress.phase.name + ' - План',
                      from: progress.planStartDate,
                      to: !!progress.planEndDate
                        ? new Date(progress.planEndDate)
                        : new Date(),
                      classes: ['section-2'],
                    }
                  : null,
              ].filter((n) => n),
            });

            // собираем данные подэтапов
            getPhaseProgresses(progress.phase.id).forEach(
              (phaseProgress, phaseProgressIndex) => {
                phaseProgressIndex = phaseProgressIndex + 1;

                rows.push({
                  name: `${progressIndex}.${phaseProgressIndex}. ${phaseProgress.name}`,
                  tasks: [
                    !!phaseProgress.startDate
                      ? {
                          name: phaseProgress.name + ' - Факт',
                          from: phaseProgress.startDate,
                          to: !!phaseProgress.endDate
                            ? Math.min(
                                new Date(phaseProgress.endDate),
                                new Date()
                              )
                            : new Date(),
                          classes: ['section-1'],
                        }
                      : null,
                    !!phaseProgress.planStartDate
                      ? {
                          name: phaseProgress.name + ' - План',
                          from: phaseProgress.planStartDate,
                          to: !!phaseProgress.planEndDate
                            ? new Date(phaseProgress.planEndDate)
                            : new Date(),
                          classes: ['section-2'],
                        }
                      : null,
                  ].filter((n) => n),
                  parent: processName,
                });
              }
            );
          });
          $scope.data = rows.filter((row) => row.tasks.length);
        }

        // endregion
      },
    ],
  };
}
